<script>
import Games from "@/services/Games";
import Teams from "@/services/Teams";
import modalEditMiniGameStreak from "@/components/modals/games/modalEditMiniGameStreak.vue";
import modalUpdateStreakDate from "@/components/modals/customers/modalUpdateStreakDate.vue";

export default {
  props: {
    customer_id: String,
  },
  components: {
    modalEditMiniGameStreak,
    modalUpdateStreakDate,
  },
  data() {
    return {
      selectedMatch: "",
      matches: [],
      showLoader: false,
      showLoader1: false,
      score: [],
      modalData: {},
      LeaderboardData: {},
      selectedMatchDetails: {},
      home_team_logo: "",
      away_team_logo: "",
      home_team_name: "",
      away_team_name: "",
      position: "",
      home_team_score_guess: "",
      away_team_score_guess: "",
      participation: "",
      isBusy: false,
      hasGuessTheScoreData: true,
      hasGuessMomData: true,
      hasMomData: "",
      MomData: "",
      MatchMomData: [],
      MatchMomDataAll: [],
      player_id: "",
      player_name: "",
      player_position: "",
      correct_vote: "",
      loading: false,
      playerImage: "",
      imageKey: 0,
      activeTabGames: 0,
      showLoaderMGL: false,
      selectedGameId: "",
      uniqueGameIds: [],
      sortBy: "position",
      sortDesc: 'false',
      totalPages: 0,
      totalItems: 0,
      currentPage: 1,
      perPage: 10,
      filter: '',
      leaderboardMG: [],
      showLoaderMG: false,
      showInitialMG: false,
      showStreakModal: false,
      streakModalData: {
        customer_id: "",
        game_id: "",
        streak: 0,
      },
      showStreakWarning: false,
      streakCalendar: [],
      showLoaderStreak: false,
      streakHoveredDay: null,
      streakTooltipTimeout: null,
      streakTooltipStyle: {},
      streakUpdateModalDay: null,
      streakUpdateSubmitting: false,
      streakUpdateError: '',
      showUpdateStreakModal: false,
    };
  },
  mounted() {
    this.getLeaderboardData();
    this.matchesData();
    this.getLeaderboardMiniSetup()
  },
  watch: {
    selectedMatch(newMatch) {
      if (newMatch) {
        this.getSelectedMatchDetails(newMatch);
        this.getMatchMomData(newMatch);
        this.getFanExperienceData();
      }
    },
  },
  methods: {
    async getLeaderboardData() {
      const queryString = `type=season&customerID=${this.customer_id}`;
      this.showLoader1 = true;

      await Games.getLeaderboardData(queryString)
        .then((response) => {
          this.LeaderboardData = response.data;
          //console.log(this.LeaderboardData, "leaderbord data");
        })
        .catch((error) => {
          this.error = error.response.data.error
            ? error.response.data.error
            : "";
        })
        .finally(() => {
          this.toggleBusy();
          this.showLoader = false;
          this.showLoader1 = false;
        });
    },
    getSelectedMatchDetails(matchId) {
      const allMatches = this.matches.flat();
      const selectedMatch = allMatches.find(
        (match) => match.match_id === matchId
      );
      if (selectedMatch) {
        this.selectedMatchDetails = selectedMatch;
      } else {
        this.selectedMatchDetails = null;
      }
    },
    async getMatches(type) {
      try {
        if (process.env.VUE_APP_SPORT == 'hockey') {
          const response = await Teams.getHockeyMatches(type);
          if (response.data) {
            return response.data;
          }
        } else {
          const response = await Teams.getFootballMatches(type);
          if (response.data) {
            return response.data;
          }
        }
      } catch (error) {
        this.error = error.response.data.error ? error.response.data.error : "";
      }
    },

    normalizeMatch(match) {
      const m = { ...match };
      if (!m.score || typeof m.score !== 'object') {
        m.score = {};
      }
      if (m.score.ft_score_home == null && m.score_home != null) {
        m.score.ft_score_home = m.score_home;
        m.score.ft_score_away = m.score_away;
      }
      return m;
    },

    async matchesData() {
      this.isBusy = true;
      var upcomingMatches = await this.getMatches("UPCOMING");
      var pastMatches = await this.getMatches("PAST");
      var pastMatchTemp = [];
      var upcomingMatchTemp = [];

      if (upcomingMatches != null && upcomingMatches.matches && upcomingMatches.matches.length > 0) {
        upcomingMatchTemp = upcomingMatches.matches;
      }
      if (pastMatches != null && pastMatches.matches && pastMatches.matches.length > 0) {
        pastMatchTemp = pastMatches.matches;
      }
      this.matches = upcomingMatchTemp.concat(pastMatchTemp).map((match) => this.normalizeMatch(match));
      this.isBusy = false;

      if (this.matches.length > 0) {
        this.selectedMatch = this.matches[0].match_id;
      }
    },

    async getFanExperienceData() {
      this.MomData = [];
      this.score = [];
      this.hasGuessTheScoreData = false;
      this.hasGuessMomData = false;

      this.loading = true;

      try {
        await Games.getScorePrediction(this.customer_id, {
          params: {
            match_id: this.selectedMatch,
          },
        })
          .then((response) => {
            this.score = response.data.data;
            this.hasGuessTheScoreData = true;
          })
          .catch((error) => {
            this.hasGuessTheScoreData = false;
            this.error = error.response.data.error
              ? error.response.data.error
              : "";
          });
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.loading = false;
      }
    },

    async getMatchMomData(selectedMatch) {
      var filterParams = 'customer_id=' + this.customer_id;
      Games.getMatchMotmData(this.selectedMatch, filterParams)
        .then((response) => {
          if (response.data.data) {
            this.MatchMomData = response.data.data;
            this.votedPlayer = this.MatchMomData.votedPlayer;
             if (this.votedPlayer != null) {
                this.hasGuessMomData = true;
              } else {
                this.hasGuessMomData = false;
              }
            this.player_id = this.MatchMomData.motmPlayer.player_id;
            this.playerImage = this.MatchMomData.motmPlayer.player_img;
            this.imageKey += 1;
          } else {
            this.MatchMomData = [];
          }
          this.toggleBusy();
        })
        .catch((error) => {
          this.error = error.response.data.error
            ? error.response.data.error
            : "";
          this.toggleBusy();
        });
    },
    async getLeaderboardMiniSetup() {
      try {

        const response = await Games.getLeaderboardMiniSetup();
        const leaderboardData = response.data

        if (leaderboardData && Array.isArray(leaderboardData.data) && leaderboardData.data.length > 0) {
          const gameIds = leaderboardData.data.map(item => item.game_id);
          this.uniqueGameIds = [...new Set(gameIds)];

          /* if (!this.leaderboardGame && this.uniqueGameIds.length > 0) {
             this.leaderboardGame = this.uniqueGameIds[0];
           }*/
        } else {
          console.log("No data found in response", leaderboardData);
        }
      } catch (error) {
        console.error("Error fetching leaderboard data:", error)
        this.error = error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : "An unexpected error occurred."
      }
    },

    onGameIdChange(){
      this.showInitialMG = true
      this.getLeaderboardDataMini()
    },

    async getLeaderboardDataMini() {
      try {
         this.totalPages = 0
         this.totalItems = 0
         this.showLoaderMG = true

        if (this.selectedGameId === '') {
          this.showLoaderMG = true
          return false;
        }

        let data = `type=season&game_id=${this.selectedGameId}&customerID=${this.customer_id}`;
        let filterData = this.setPaginationFilters(data);

        const response = await Games.getLeaderboardMini(filterData);
        var leaderboardMG = response.data;
        console.log(leaderboardMG)
        this.leaderboardMG = leaderboardMG

        this.showLoaderMG = false;

        if (leaderboardMG.game_type === 'streak') {
          this.getStreakCalendar();
        } else {
          this.streakCalendar = [];
        }
      } catch (error) {
        console.error("Error fetching leaderboard data:", error);
        this.error = error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : "An unexpected error occurred.";
        this.showLoaderMG = false;
      }
    },

    setPaginationFilters(data){
      let sortDesc = (this.sortDesc === true) ? 'DESC' : 'ASC';
      let sortBy = (this.sortBy !== undefined) ? this.sortBy : '';

      data += '&page='+this.currentPage+'&limit='+this.perPage+'&orderBy='+sortBy+'&order='+sortDesc

      if(this.filter.trim() !== ''){
        data += '&filter='+this.filter
      }

      return data;
    },

    openStreakModal() {
      if (!this.leaderboardMG || !this.leaderboardMG.customer_current_streak) {
        return;
      }
      this.streakModalData = {
        customer_id: this.customer_id,
        game_id: this.selectedGameId,
        streak: this.leaderboardMG.customer_current_streak.current_streak,
      };
      this.$bvModal.show("edit_mini_game_streak");
    },

    async refreshMiniLeaderboard() {
      await this.getLeaderboardDataMini();
      this.showStreakWarning = true;
    },


    async getStreakCalendar() {
      if (!this.selectedGameId || !this.customer_id) return;
      this.showLoaderStreak = true;
      this.streakCalendar = [];
      try {
      
        const response = await Games.getMiniGamesStreakCalendar(this.selectedGameId, this.customer_id);
        if (response.data && response.data.data && response.data.data.calendar) {
          this.streakCalendar = response.data.data.calendar.map(day => {
            const d = new Date(day.date);
            const dateLabel = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
            let tooltip, cssClass;
            if (day.success === null) {
              tooltip = dateLabel + ' - Not played';
              cssClass = 'text-secondary';
            } else if (day.success === 1) {
              tooltip = dateLabel + ' - Won (streak: ' + day.streak + ')';
              cssClass = 'text-success';
            } else {
              tooltip = dateLabel + ' - Lost';
              cssClass = 'text-danger';
            }
            return { ...day, dayNum: d.getDate(), tooltip, cssClass };
          });
        }
      } catch (error) {
        console.error("Error fetching streak calendar:", error);
      } finally {
        this.showLoaderStreak = false;
      }
    },

    onStreakEnter(day, event) {
      if (this.streakTooltipTimeout) {
        clearTimeout(this.streakTooltipTimeout);
        this.streakTooltipTimeout = null;
      }
      this.streakHoveredDay = day;
      const el = event.currentTarget;
      if (el) {
        const rect = el.getBoundingClientRect();
        this.streakTooltipStyle = {
          top: (rect.top - 28) + 'px',
          left: (rect.left + rect.width / 2) + 'px',
          transform: 'translateX(-50%)',
        };
      }
    },

    onStreakLeave() {
      this.streakTooltipTimeout = setTimeout(() => {
        this.streakHoveredDay = null;
      }, 150);
    },

    openUpdateStreakModal(day) {
      if (day.success === 1) return;
      this.streakUpdateModalDay = day;
      this.streakUpdateError = '';
      this.showUpdateStreakModal = true;
    },

    closeUpdateStreakModal() {
      this.showUpdateStreakModal = false;
      this.streakUpdateModalDay = null;
      this.streakUpdateError = '';
      this.streakUpdateSubmitting = false;
    },

    async confirmUpdateStreakDate() {
      if (!this.streakUpdateModalDay || !this.selectedGameId || !this.customer_id) return;
      this.streakUpdateSubmitting = true;
      this.streakUpdateError = '';
      try {
        const payload = {
          game_id: this.selectedGameId,
          customer_id: this.customer_id,
          date: this.streakUpdateModalDay.date,
        };
        const response = await Games.updateMiniGamesStreak(payload);
        if (response.data && response.data.success) {
          this.closeUpdateStreakModal();
          await this.getStreakCalendar();
          await this.getLeaderboardDataMini();
        } else {
          this.streakUpdateError = (response.data && response.data.error) || 'Update streak failed';
        }
      } catch (e) {
        this.streakUpdateError = e.response?.data?.error || e.response?.data?.message || 'Update streak failed';
      } finally {
        this.streakUpdateSubmitting = false;
      }
    },

  },
  computed: {
    streakCalendarLinear() {
      if (!this.streakCalendar.length) return [];
      const sorted = [...this.streakCalendar].sort((a, b) => new Date(a.date) - new Date(b.date));
      let prevMonthKey = null;
      return sorted.map((day, idx) => {
        const d = new Date(day.date);
        const monthKey = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
        const isMonthStart = idx === 0 || (prevMonthKey !== null && monthKey !== prevMonthKey);
        prevMonthKey = monthKey;
        return {
          ...day,
          _monthStart: isMonthStart,
          _monthLabel: d.toLocaleDateString('en-GB', { month: 'short' }),
        };
      });
    },
  },
};
</script>

<template>
  <div>
  <b-tabs content-class="p-1" justified class="nav-tabs-custom">
    <b-tab active>
      <template v-slot:title>
        <i class="uil uil-trophy font-size-20"></i>
        <span class="d-none d-sm-block">MDC Leaderboard</span>
      </template>
      <div class="row mb-5" v-if="!showLoader1">
        <div class="col-sm-12 col-md-12">
          <div class="row  d-flex justify-content-around">
            <div class="col-sm-12" style="font-size: 17px; font-weight: bold;">
              <!-- <h5 class="text-center">
                Season tickets for {{ LeaderboardData.type_id }}
              </h5>
               -->
              <h5 class="text-center">
                Fanzone data for {{ LeaderboardData.type_id }}
              </h5>
            </div>
            <div v-if="!this.LeaderboardData.customer_placement">
              <h3 class="mt-2 text-center">
                No data found
              </h3>
            </div>
            <div class="row mb-5 d-flex justify-content-around" v-else>
              <div class="col-md-3">
                <div class="card bg-gradient-light h-80">
                  <div class="card-body d-grid">
                    <div>
                      <h5 class="text-muted mb-0 text-center">Position</h5>
                    </div>
                    <h4
                        class="mt-3 align-self-end text-center"
                        v-if="
                        LeaderboardData && LeaderboardData.customer_placement
                      "
                    >
                      <span data-plugin="counterup" v-if="!showLoader1">
                        {{ this.LeaderboardData.customer_placement.position }}
                      </span>
                      <div
                          class="container-fluid d-flex justify-content-center align-items-center h-50"
                          v-else
                      >
                        <b-spinner large></b-spinner>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="card bg-gradient-light h-80">
                  <div class="card-body d-grid">
                    <div>
                      <h5 class="text-muted mb-0 text-center">Points</h5>
                    </div>
                    <h4
                        class="mt-3 align-self-end text-center"
                        v-if="
                        LeaderboardData && LeaderboardData.customer_placement
                      "
                    >
                      <span data-plugin="counterup" v-if="!showLoader1">
                        {{ LeaderboardData.customer_placement.score }}
                      </span>
                      <div
                          class="container-fluid d-flex justify-content-center align-items-center h-50"
                          v-else
                      >
                        <b-spinner large></b-spinner>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="card bg-gradient-light h-80">
                  <div class="card-body d-grid">
                    <div>
                      <h5 class="text-muted mb-0 text-center">Participation</h5>
                    </div>
                    <h4
                        class="mt-3 align-self-end text-center"
                        v-if="
                        LeaderboardData && LeaderboardData.customer_placement
                      "
                    >
                      <span data-plugin="counterup" v-if="!showLoader1">
                        {{ LeaderboardData.customer_placement.participation }} /
                        {{ LeaderboardData.customer_placement.matches_played }}
                      </span>
                      <div
                          class="container-fluid d-flex justify-content-center align-items-center h-50"
                          v-else
                      >
                        <b-spinner large></b-spinner>
                      </div>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row text-center" v-if="LeaderboardData.customer_placement">
            <div class="mb-6 col-md-6  mx-auto">
              <div class="form-row form-group mb-3">
                <label class="col-md-12 text-center col-form-label"
                >Select Match</label
                >
                <select
                    class="form-select"
                    v-model="selectedMatch"
                    @change="getFanExperienceData()"
                    id="selectMatch"
                >
                  <option
                      v-for="match in matches"
                      :key="match.match_id"
                      :value="match.match_id"
                  >
                    {{ match.home_team_name }} - {{ match.away_team_name }} /
                    <span class="ms-2">{{ match.date_formatted || match.date_time }}</span>
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedMatch">
          <div v-if="MatchMomData.score.isCalculated">
            <h4 class="text-center mt-5" v-if="LeaderboardData">
              Match Details
            </h4>
            <div class="row">
              <div class="col-6">
                <div class="row fe-crm text-center d-flex justify-content-center align-items-center">
                  <h4 class="text-center" v-if="LeaderboardData.customer_placement">
                    Guess the Score Prediction
                  </h4>
                  <div class="col-md-3" v-if="selectedMatchDetails && selectedMatchDetails.home_team_logo">
                    <div class="team-holder">
                      <img
                          class="img-responsive"
                          :src="selectedMatchDetails.home_team_logo"
                          style="max-width: 100%"
                          alt="Home Team Logo"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="clearfix"></div>
                      <div
                          class="col-lg-5 text-center home-result"
                          v-if="selectedMatchDetails && selectedMatchDetails.score"
                      >
                <span style="font-size: 18px; font-weight: 800">{{
                    selectedMatchDetails.score.ft_score_home
                  }}</span>
                      </div>
                      <div
                          class="col-lg-3 vs"
                          v-if="selectedMatchDetails && selectedMatchDetails.score"
                      >
                        :
                      </div>
                      <div
                          class="col-lg-4 text-center away-result"
                          v-if="selectedMatchDetails && selectedMatchDetails.score"
                      >
                <span style="font-size: 18px; font-weight: 800">{{
                    selectedMatchDetails.score.ft_score_away
                  }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div
                        class="team-holder right"
                        v-if="selectedMatchDetails && selectedMatchDetails.away_team_logo"
                    >
                      <img
                          class="img-responsive"
                          :src="selectedMatchDetails.away_team_logo"
                          style="max-width: 100%"
                          alt="Away Team Logo"
                      />
                    </div>
                  </div>

                </div><!--      team logo-->
              </div>
              <div class="col-6">
                <div class="row fe-crm text-center d-flex justify-content-center align-items-center" v-if="MatchMomData.motmPlayer &&MatchMomData.motmPlayer.player_name !== '' ">
                  <h4 class="text-center">
                    Man of the Match
                  </h4>
                  <div class="col-4">
                    <img
                        v-if="playerImage"
                        :src="playerImage + '?key=' + imageKey"
                        alt="Player Image"
                        style="max-width: 100px; max-height: 100px;"
                    />
                  </div>
                  <div class="col-8">

                    <h5 class="text-center">
                      {{ MatchMomData.motmPlayer.player_name }}
                    </h5>

                    <h6 class="text-center mt-3">
                      {{ MatchMomData.motmPlayer.player_position }}
                    </h6>
                  </div>
                </div>

              </div>
            </div>
            <div class="row mt-5" v-if="!loading">
              <div class="col-6">
                <div class="card" v-if="!loading">
                  <div class="card-body">
                    <div class="row" v-if="hasGuessTheScoreData">
                      <div class="col-12">
                        <div class="text-center" v-if="score.length > 0">
                          <h5>
                            Home Team {{ score[0].home_team_score_guess }} -
                            {{ score[0].away_team_score_guess }} Away Team
                          </h5>
                          <div v-if="MatchMomData.score.isCorrect">
                            <p class="text-success">Correct Guess</p>
                          </div>
                          <div v-else>
                            <p class="text-danger">Incorrect Guess</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <h4 class="text-center text-danger">
                        No Guess the Score Prediction.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6" v-if="!loading">
                <div class="card" v-if="votedPlayer && hasGuessMomData">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <h5 class="text-center">{{ votedPlayer.player_name }}</h5>
                        <p class="text-center text-success" v-if="votedPlayer.player_id === player_id">Correct Vote</p>
                        <p class="text-center text-danger" v-else>Incorrect Vote</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card for "No Man of the Match prediction" fallback -->
                <div class="card" v-else>
                  <div class="card-body">
                    <h4 class="text-center text-danger">
                      No Man of the Match prediction.
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center mt-3">
            <h6>Match result not available yet</h6>
          </div>
          <hr />
          <div v-if="loading" class="text-center">Loading...</div>
        </div>
        <div v-else class="text-center mt-3">
          <h6>Please select match</h6>
        </div>
      </div>

      <div class="card-body d-flex align-items-center justify-content-center" v-else>
        <b-spinner large></b-spinner>
      </div>
    </b-tab>

    <b-tab>
      <template v-slot:title>
        <i class="uil uil-trophy font-size-20"></i>
        <span class="d-none d-sm-block">Mini Games Leaderboard</span>
      </template>
      <div class="row mb-5">
        <div class="col-4 col-md-4 mx-auto">
          <label class="col-md-12 text-center col-form-label">Select Game</label>
          <select class="form-select" @change="onGameIdChange" v-model="selectedGameId">
            <option v-for="gameId in uniqueGameIds" :key="gameId" :value="gameId">{{ gameId }}</option>
          </select>
        </div>
      </div>
      <div v-if="showInitialMG">
      <b-alert
        v-if="showStreakWarning"
        show
        dismissible
        variant="warning"
        @dismissed="showStreakWarning = false"
        class="text-center"
      >
        Position and streak will be updated once the leaderboard calculation is finished.
      </b-alert>
      <div class="row d-flex justify-content-around" v-if="!showLoaderMG">
        <div class="col-sm-12" style="font-size: 17px; font-weight: bold;">
          <h5 class="text-center">Fanzone data for {{ leaderboardMG.type_id }}</h5>
        </div>
        <div v-if="!leaderboardMG.customer_placement && leaderboardMG.game_type != 'streak'">
          <h3 class="mt-2 text-center">No data found</h3>
        </div>
        <div class="row mb-5 d-flex justify-content-around" v-else>
          <div class="col-md-3">
            <div class="card bg-gradient-light h-80">
              <div class="card-body d-grid">
                <div>
                  <h5 class="text-muted mb-0 text-center">Position</h5>
                </div>
                <h4 class="mt-3 align-self-end text-center" v-if="leaderboardMG && leaderboardMG.customer_placement">
                      <span data-plugin="counterup" v-if="!showLoaderMG">
                        {{ leaderboardMG.customer_placement.position }}
                      </span>
                  <div class="container-fluid d-flex justify-content-center align-items-center h-50" v-else>
                    <b-spinner large></b-spinner>
                  </div>
                </h4>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="card bg-gradient-light h-80">
              <div class="card-body d-grid">
                <div>
                  <h5 class="text-muted mb-0 text-center">{{ leaderboardMG.game_type == 'streak' ? 'Streak' : 'Points' }}</h5>
                </div>
                <h4 class="mt-3 align-self-end text-center" v-if="leaderboardMG && leaderboardMG.customer_placement">
                      <span data-plugin="counterup" v-if="!showLoaderMG">
                        {{ leaderboardMG.customer_placement.score }}
                      </span>
                  <div class="container-fluid d-flex justify-content-center align-items-center h-50" v-else>
                    <b-spinner large></b-spinner>
                  </div>
                </h4>
              </div>
            </div>
          </div>

          <div class="col-md-3" v-if="leaderboardMG.game_type == 'streak'">
            <div class="card bg-gradient-light h-80 streak-card">
              <div class="card-body d-grid">
                <div class="d-flex justify-content-center align-items-center">
                  <h5 class="text-muted mb-0 text-center">Current Streak</h5>
                </div>
                <h4 class="mt-3 align-self-end text-center" v-if="leaderboardMG && leaderboardMG.customer_current_streak">
                      <span data-plugin="counterup" v-if="!showLoaderMG">
                        {{ leaderboardMG.customer_current_streak.current_streak }}
                      </span>
                  <div class="container-fluid d-flex justify-content-center align-items-center h-50" v-else>
                    <b-spinner large></b-spinner>
                  </div>
                </h4>
              </div>
            </div>
          </div>

        </div>

        <div class="row mt-3" v-if="leaderboardMG.game_type == 'streak'">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h5 class="text-muted mb-3">Streak for last 30 days</h5>
                <div v-if="showLoaderStreak" class="text-center">
                  <b-spinner small></b-spinner> Loading...
                </div>
                <div v-else-if="streakCalendar.length > 0" class="streak-calendar-wrapper" @mouseleave="onStreakLeave">
                  <div class="d-flex flex-nowrap streak-days-row">
                    <span
                      v-for="(day, di) in streakCalendarLinear"
                      :key="day.date + '-' + di"
                      class="streak-day-item"
                      :class="{ 'streak-day-hovered': streakHoveredDay === day, 'streak-day-clickable': day.success !== 1 }"
                      @mouseenter="onStreakEnter(day, $event)"
                      @mouseleave="onStreakLeave"
                      @click="day.success !== 1 && openUpdateStreakModal(day)"
                    >
                      <span v-if="day._monthStart" class="streak-month-chip">{{ day._monthLabel }}</span>
                      <span class="text-muted streak-day-num">{{ day.dayNum }}</span>
                      <i :class="day.cssClass" class="fa fa-square streak-day-square"></i>
                    </span>
                  </div>
                  <div v-if="streakHoveredDay" class="streak-custom-tooltip" :style="streakTooltipStyle">
                    {{ streakHoveredDay.tooltip }}
                  </div>
                </div>
                <div v-else>
                  <span class="text-muted">No streak data available</span>
                </div>
                <div class="mt-2">
                  <small>
                    <i class="fa fa-square text-success me-1"></i> Won
                    <i class="fa fa-square text-danger me-1 ms-2"></i> Lost
                    <i class="fa fa-square text-secondary me-1 ms-2"></i> Not played
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-else class="text-center mb-5">Loading...</div>
      </div>
    </b-tab>
  </b-tabs>

  <modalEditMiniGameStreak
    :customerId="streakModalData.customer_id"
    :gameId="streakModalData.game_id"
    :currentStreak="streakModalData.streak"
    @onRefresh="refreshMiniLeaderboard"
  />

  <modalUpdateStreakDate
    :visible.sync="showUpdateStreakModal"
    :day="streakUpdateModalDay"
    :submitting="streakUpdateSubmitting"
    :error="streakUpdateError"
    @confirm="confirmUpdateStreakDate"
    @hidden="closeUpdateStreakModal"
    @cancel="closeUpdateStreakModal"
  />
  </div>
</template>

<style scoped>
.streak-card .card-body {
  position: relative;
}

.streak-card .streak-edit-btn {
  position: absolute;
  top: 6px;
  right: 8px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease-in-out;
}

.streak-card:hover .streak-edit-btn {
  opacity: 1;
  pointer-events: auto;
}

.streak-calendar-wrapper {
  position: relative;
}

.streak-days-row {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: hidden;
  overflow-y: visible;
  padding-top: 14px;
}

.streak-day-item {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1 1 0;
  min-width: 14px;
  max-width: 26px;
  margin-right: 2px;
  padding: 2px 2px;
  border-radius: 4px;
  cursor: default;
  transition: background-color 0.15s ease;
}

.streak-month-chip {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 9px;
  line-height: 1;
  font-weight: 600;
  color: #6c757d;
  background: rgba(255, 255, 255, 0.9);
  padding: 1px 4px;
  border-radius: 10px;
  white-space: nowrap;
  pointer-events: none;
}

.streak-day-item:hover,
.streak-day-hovered {
  background-color: rgba(0, 0, 0, 0.06);
}

.streak-day-clickable {
  cursor: pointer;
}

.streak-day-num {
  font-size: 9px;
  line-height: 1.2;
}

.streak-day-square {
  font-size: 12px;
}

.streak-custom-tooltip {
  position: fixed;
  z-index: 1070;
  padding: 6px 12px;
  font-size: 12px;
  color: #fff;
  background: #333;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  pointer-events: none;
  animation: streak-tooltip-fade 0.15s ease;
}

@keyframes streak-tooltip-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
